/**
 * Productgids overview — always use the Shopify product featured/hero image.
 * Replaces placeholders and any stale lifestyle/index thumbnails.
 */
(function () {
  'use strict';

  var BATCH = 8;

  function productJsonUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function fileKey(url) {
    if (!url) return '';
    return String(url).split('?')[0].split('/').pop();
  }

  function pickImage(product) {
    if (!product) return null;
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images.length) return product.images[0];
    if (product.media && product.media.length && product.media[0].preview_image) {
      return product.media[0].preview_image.src;
    }
    return null;
  }

  function applyImage(card, url, alt) {
    var media = card.querySelector('.mpg-product-card__media');
    if (!media || !url) return;
    var img = media.querySelector('.mpg-product-card__img');
    if (img) {
      if (fileKey(img.getAttribute('src') || img.src) !== fileKey(url)) {
        img.src = url;
      }
      if (alt) img.alt = alt;
    } else {
      var placeholder = media.querySelector('.mpg-product-card__placeholder');
      img = document.createElement('img');
      img.className = 'mpg-product-card__img';
      img.src = url;
      img.alt = alt || '';
      img.width = 400;
      img.height = 400;
      img.loading = 'lazy';
      img.decoding = 'async';
      if (placeholder) placeholder.replaceWith(img);
      else media.prepend(img);
    }

    var askBtn = card.querySelector('.mpic-open-drawer');
    if (askBtn) askBtn.setAttribute('data-mpic-image', url);
  }

  function fetchHandle(handle) {
    return fetch(productJsonUrl(handle), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () {
        return null;
      });
  }

  function loadProductImage(entry) {
    var handles = [entry.handle];
    if (entry.fallbackHandle && entry.fallbackHandle !== entry.handle) {
      handles.push(entry.fallbackHandle);
    }

    function tryNext(index) {
      if (index >= handles.length) return Promise.resolve();
      return fetchHandle(handles[index]).then(function (product) {
        var url = pickImage(product);
        if (url) {
          applyImage(entry.card, url, product && product.title ? product.title : '');
          return;
        }
        return tryNext(index + 1);
      });
    }

    return tryNext(0);
  }

  function processBatch(queue) {
    if (!queue.length) return Promise.resolve();
    var batch = queue.splice(0, BATCH);
    return Promise.all(
      batch.map(function (entry) {
        return loadProductImage(entry);
      })
    ).then(function () {
      return processBatch(queue);
    });
  }

  function init() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.mpg-product-card[data-product-handle]'));
    var queue = [];

    cards.forEach(function (card) {
      var handle = card.getAttribute('data-product-handle');
      if (!handle) return;
      var fallbackHandle = card.getAttribute('data-product-fallback-handle') || '';
      queue.push({ card: card, handle: handle, fallbackHandle: fallbackHandle });
    });

    if (!queue.length) return;
    processBatch(queue);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
